module.exports = __webpack_public_path__ + "static/media/superbowl-50.703bd11c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/superbowl-50.jpg
// module id = 118
// module chunks = 0